const formModel = {
    formId: "formModel",
    formField: {
        muti_currency: {
            name: "muti_currency",
            label: "Select Curreny",
            requiredErrorMsg: "Please Select Any currency",
        },
        wl_primarycolor: {
            name: "wl_primarycolor",
            label: "Natural Primary Color",
            requiredErrorMsg: "Natural Primary Color is Required",
        },
        n_fontcolor: {
            name: "n_fontcolor",
            label: "Natural Font Color",
            requiredErrorMsg: "Natural Font Color is Required",
        },
        lab_primary: {
            name: "lab_primary",
            label: "Labgrown Primary Color",
            requiredErrorMsg: "Labgrown Primary Color is Required",
        },
        lab_fontcolor: {
            name: "lab_fontcolor",
            label: "Labgrown Font Color",
            requiredErrorMsg: "Labgrown Font Color is Required",
        },
        theme: {
            name: "theme",
            label: "Select Theme",
            classes: "polishes",
            requiredErrorMsg: "Theme selection is Required",
        },
        tax_value: {
            name: "tax_value",
            label: "Tax Value",
            requiredErrorMsg: "Tax Value is Required",
        },
        tax_name: {
            name: "tax_name",
            label: "Tax Name",
            requiredErrorMsg: "Tax Name is Required",
        },
        taxinclusive: {
            name: "taxinclusive",
            label: "taxinclusive",
            requiredErrorMsg: "taxinclusive is required",
        },
        noprice: {
            name: "noprice",
            label: "noprice",
            requiredErrorMsg: "Please Select",
        },
        multilanguage: {
            name: "multilanguage",
            label: "multilanguage",
            requiredErrorMsg: "Please Select Language",
        },
        show_custom_detail_page: {
            name: "show_custom_detail_page",
            label: "show_custom_detail_page",
            requiredErrorMsg: "Please choose to show custom detail page",
        },
    },
};

export default formModel;
